import Vue from 'vue'
import { axios } from '../../../plugins/axios'

export default {
  namespaced: true,

  state: {
    evaluacionesPersonal: {},
    selectedEvaluation: null,
  },

  getters: {
    getEvaluacionesPersonal: (state) => {
      return state.evaluacionesPersonal
    },

    getSelectedEvaluation: (state) => {
      return state.selectedEvaluation
    },
  },

  mutations: {
    SET_EVALUACIONES_PERSONAL(state, evaluacionesPersonal) {
      state.evaluacionesPersonal = evaluacionesPersonal
    },

    SET_SELECTED_EVALUATION(state, evaluation) {
      Vue.set(state, 'selectedEvaluation', evaluation)
    },
  },

  actions: {
    fetchEvaluacionesById: async function ({ commit }, idPersonal) {
      await axios
        .get('/PoliciaCuadrantes/DesarrolloPolicial/evaluador/' + idPersonal + '/evaluaciones')
        .then((response) => {
          commit('SET_EVALUACIONES_PERSONAL', response.data.data[0])
        })
        .catch((error) => console.log(error))
    },
  },
}
